import {translate} from 'localization';
import type {Thesaurus, ThesaurusNode} from '../types';
import {modifyThesaurusNodeByIds} from './modifyThesaurusNodeByIds';

export const modifyThemaThesaurus = (thesaurus: Thesaurus): Thesaurus => {
  if (thesaurus.id !== 'thema') {
    return thesaurus;
  }

  const letterChildren =
    thesaurus.children?.filter(c => c.id.match('[a-zA-Z]')) ?? [];
  const topLevelLetters: ThesaurusNode = {
    id: 'A-Z',
    code: 'A-Z',
    label: translate('thesaurus.thema.subject.label'),
    children: letterChildren,
  };

  const numberChildren =
    thesaurus.children?.filter(c => c.id.match('[0-9]')) ?? [];

  thesaurus.children = modifyThesaurusNodeByIds(
    [topLevelLetters, ...numberChildren],
    // Reference to hardcoded values.
    // https://bokbasen.jira.com/browse/BB-9487
    // Handled by backend in future, else specify as CodelistRef.
    ['5T*', '5YH', '5HKD', '5HKW', '5HKY', '5HKZ', '5PH*'],
    {
      selectable: false,
    },
  );

  return thesaurus;
};
